import { ReactElement } from 'react';
import { NotificationBell } from '../NotificationCenter/NotificationBell';
import classes from './TopBar.module.css';

/** The bar over every page on a large screen, with the bell at the top right where people look for it */
export const TopBar = (): ReactElement => (
  <header className={classes.topBar} data-print="false">
    <div className={classes.actions}>
      <NotificationBell />
    </div>
  </header>
);
